module.exports = __webpack_public_path__ + "static/media/security.ad0295f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/security.png
// module id = 1580
// module chunks = 0